<template>
  <Scroll :height="height">
    <Form
      ref="formValidate"
      :model="formValidate"
      :rules="ruleValidate"
      :label-width="100"
      style="text-align:left"
    >
      <FormItem v-for="(value, key) in checkItem" :key="key" :label="key" prop="check">
        <Select v-model="formValidate[value.value]" placeholder="请选择安检状态">
          <Option v-for="item in value.option" :value="item" :key="item">{{item}}</Option>
        </Select>
      </FormItem>

      <FormItem label="表规格" prop="spec">
        <Select v-model="formValidate.spec" placeholder="请选择设备规格">
          <Option v-for="item in specificationsEnum" :value="item" :key="item">{{item}}</Option>
        </Select>
      </FormItem>
      <FormItem label="表底数（m³）" prop="base">
        <Input v-model="formValidate.base" type="number" @on-blur="onBlurBase" placeholder="请输入表底数"></Input>
      </FormItem>
      <FormItem label="表读数（m³）" prop="read">
        <Input v-model="formValidate.read" placeholder="请输入表读数"></Input>
      </FormItem>
      <FormItem label="安检结果">
        <Select v-model="formValidate.result" >
          <Option v-for="(value, key) in checkResultEnum" :value="value" :key="key">{{value}}</Option>
        </Select>
      </FormItem>
      <FormItem label="备注" prop="remark">
        <Input
          v-model="formValidate.remark"
          type="textarea"
          :autosize="{minRows: 2,maxRows: 5}"
          placeholder="请输入备注"
        ></Input>
      </FormItem>
    </Form>
  </Scroll>
</template>
<script>
export default {
  methods: {
    onBlurBase(){
      this.formValidate.base = parseFloat(this.formValidate.base).toFixed(3);
    },
    getFormItems() {
      this.$refs.formValidate.validate(valid => {
        if (valid) {
          this.validatResult = true;
        } else {
          this.$Notice.warning({
            title: "提示",
            desc: "请完善安检信息"
          });
          this.validatResult = false;
        }
      });

      if (this.validatResult) {
        return this.formValidate;
      } else {
        return null;
      }
    }
  },
  mounted() {},
  created() {
    // this.height = document.body.clientHeight - 42;
    // this.width = document.body.clientWidth;
    for (let i in this.checkItem) {
      this.formValidate[this.checkItem[i].value] = this.checkItem[i].option[0];
    }
  },
  data() {
    return {
      validatResult: true,
      checkResultEnum: global.checkResult,
      checkItem: global.checkItem,
      height: document.body.clientHeight * 0.7,
      commTypeEnum: global.communicateType,
      meterTypeEnum: global.meterType,
      manufacturerEnum: global.manufacturer,
      specificationsEnum: global.specifications,

      formValidate: {
        result: "正常安检"
      },
      ruleValidate: {
        spec: [
          {
            required: true,
            message: "请选择表具规格",
            trigger: "blur"
          }
        ],
        base: [
          {
            required: true,
            message: "请输入表底数",
            trigger: "blur"
          }
        ],
        read: [
          {
            required: true,
            message: "请输入表读数",
            trigger: "blur"
          }
        ]
      }
    };
  }
};
</script>
